import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import useNfd from '../hooks/useNfd';
import Button from './Button';
import Container from './Container';
import Form from './Form';
import Input from './Input';
import PageHeader from './PageHeader';
import TopUsersFeed from './TopUsersFeed';

const TheProfileSearchPage = ({ title, description }) => {
  const { getAddress } = useNfd();
  const form = useForm();
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (args) => {
    setLoading(true);
    const isAddress = args.address.length === 58;

    let address = null;
    if (!isAddress) {
      const nfd = await getAddress(args.address);
      address = nfd?.depositAccount;
    } else {
      address = args.address;
    }

    if (!address) {
      setLoading(false);
      toast.error('Address not found');
      return;
    }

    router.push(`/profile/${address}`);
  };

  return (
    <div>
      <PageHeader heading={title} description={description} />

      <Container>
        <div className='pb-12 lg:pb-24 pt-12 flex justify-center'>
          <Form onSubmit={handleSubmit} form={form} className='flex items-center flex-col gap-5 max-w-xl w-full relative'>
            <div className='relative w-full'>
              <div className='absolute top-0 bottom-0 left-4 flex items-center justify-center text-gray-500'>
                <svg className='w-[24px] h-[24px]' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                  <path
                    d='M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z'
                    fill='currentColor'
                  />
                </svg>
              </div>
              <Input type='text' placeholder='Type address or NFD...' name='address' required fullWidth className='py-6 pl-[60px] pr-3 text-[20px]' />
            </div>
            <Button loading={loading} type='submit'>
              Search
            </Button>
          </Form>
        </div>

        <TopUsersFeed />
      </Container>
    </div>
  );
};

export default TheProfileSearchPage;
